<template>
    <div class="c-loading-bar"></div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.c-loading-bar {
    background: repeating-linear-gradient(
        to right,
        var(--gangl-color-red) 0%,
        var(--gangl-color-berater) 50%,
        var(--gangl-color-red) 100%
    );
    width: 100%;
    background-size: 200% auto;
    background-position: 0 100%;
    animation: gradient 2s infinite;
    animation-fill-mode: forwards;
    animation-timing-function: linear;
    height: 3px;
    position: absolute;
}

@keyframes gradient {
    0% {
        background-position: 0 0;
    }
    100% {
        background-position: -200% 0;
    }
}
</style>
